import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import axios from "axios";
import { constants, environmentVariables } from "../../Shared/Url/Constants";
import Cookie from "js-cookie";
import classes from "./dailyavailabilitytile.module.scss";
import seIcon from "../../Resources/homepage/sptab/BLOOM-Special-Events.png";
import {
  KeyDaysIcon,
  PTOIcon,
  SpecialEventIcon,
  UnavailableDaysIcon,
  AccomodationsIcon,
  IconStatus
} from "../../Resources/availabilityicon/AvailabilityIcons";
import AvailabilitySelectionsDailyPopup from "../AvailabilitySelections/AvailabilitySelectionsDailyPopup";
import { isEmpty, toUpperCaseString } from "../../Shared/Utill/Utills";
import { useLocation, useNavigate } from "react-router-dom";

const DailyAvailabilityTile = (props) => {
  const [showPopup, setShowPopup] = React.useState(false);
  const [popupdata, setPopupData] = React.useState({});
  const [dailyTilesData, setDailyTilesData] = React.useState([]);
  const [rulesData, setRulesData] = React.useState([]);
  const [appControlsData,setAppControlsData] = React.useState([]);
  const history = useNavigate();
  const languageDetails = useSelector((state) => state.selectedLanguage.selectedLanguageData);
  //const [isAllTileDisabled, setAllTileDisabled] = React.useState(null);

  useEffect(() => {
    console.log("DailyData-----" + props.dailyData);
    setDailyTilesData(props.dailyData);
    setRulesData(props.ruleData);
    setAppControlsData(props.appControls);
    console.log("Rule Data-----" + JSON.stringify(props.ruleData));
  }, [props.dailyData, props.ruleData, props.appControls]);

  useEffect(() =>{
    callBackDisabled();
  },[rulesData,dailyTilesData]);
  // Edit daily popup

  const selectAvailability = (tileObj) => {
    console.log("Selected Tile Data-----" + JSON.stringify(tileObj));
    setPopupData(tileObj);
    setShowPopup(true);
  };

  const popupClose = () => {
    setShowPopup(false);
  };

  const gotoSpecial = () => {
    history('/specialevents')
  }

  const onUpdateAvailabilitySuccess = (severity, message = "Daily Availability Saved Successfully") => {
    setShowPopup(false);
    props.showSuccessMessage(severity,message);
  };

  function AvailabilityInfoView(props) {
    let e = props.data;
    let isDisabled = isTileDisabled(e);
    let avlRuleTileLocked = isAvailabilityRuleTileLocked(e);
    if(isAccomTypeDAYOFF(e)){
      return (
        <div className={classes.minheightoftile}>
          <div className={classes.setsubtitle}>My Availability</div>
          <div className={`${classes.tilecontainerua} ${isDisabled ? classes.disabled: null}`}>
            Unavailable for this day
          </div>
          <EditLinkView data={e} isEdit={true} lable={"Edit"}  isAccomOff={true}/>
        </div>
      );
    }

    if (
      !isEmpty(e.avlDayStart1) &&
      toUpperCaseString(e.avlDayStart1) == "OFF" &&
      !isEmpty(e.avlDayEnd1) &&
      toUpperCaseString(e.avlDayEnd1) == "OFF"
    ) {
      return (
        <div className={classes.minheightoftile}>
          <div className={classes.setsubtitle}>My Availability</div>
          <div className={`${classes.tilecontainerua} ${isDisabled? classes.disabled: null}`}>
            Unavailable for this day
          </div>
          <EditLinkView data={e} isEdit={true} lable={"Edit"}  isAccomOff={false}/>
        </div>
      );
    }

    if (
      isEmpty(e.avlDayStart1) &&
      isEmpty(e.avlDayEnd1) &&
      isEmpty(e.avlDayStart2) &&
      isEmpty(e.avlDayEnd2) && avlRuleTileLocked
    ) {
      return (
        <div className={classes.minheightoftile}>
        <div className={classes.setsubtitle}>My Availability</div>
        <div className={classes.minheightavl}>
          <div className={`${classes.minheightavl} ${isDisabled? classes.disabled: null}`}>
            {'OPEN-CLOSE'}
          </div>
        </div>
      </div>
      );
    }

    if (
      isEmpty(e.avlDayStart1) &&
      isEmpty(e.avlDayEnd1) &&
      isEmpty(e.avlDayStart2) &&
      isEmpty(e.avlDayEnd2) && !avlRuleTileLocked
    ) {
      return (
        <div className={classes.minheightsetavail}>
        <EditLinkView data={e} isEdit={false} lable={"Select Availability"}  isAccomOff={false}/>
        </div>
      );
    }
  
    if (isEmpty(e.avlDayStart2) && isEmpty(e.avlDayEnd2)) {
      return (
        <div className={classes.minheightoftile}>
          <div className={classes.setsubtitle}>My Availability</div>

          <div className={classes.minheightavl}>
            <div className={`${classes.minheightavl} ${isDisabled? classes.disabled: null}`} translate="no">
              {e.avlDayStart1 + "-" + e.avlDayEnd1}
            </div>
            <EditLinkView data={e} isEdit={true} lable={"Edit"}  isAccomOff={false}/>
          </div>
        </div>
      );
    }

  

    return (
      <div className={classes.minheightoftile}>
        <div className={classes.setsubtitle} >My Availability</div>
        <div className={`${classes.sedescription} ${isDisabled? classes.disabled: null}`} >
          {e.avlDayStart1 + "-" + e.avlDayEnd1}
        </div>
        <div className={`${classes.sedescription}  ${isDisabled? classes.disabled: null}`} >
          {e.avlDayStart2 + "-" + e.avlDayEnd2}
        </div>
        <EditLinkView data={e} isEdit={true} lable={"Edit"}  isAccomOff={false}/>
      </div>
    );
  }

  function TileIconsView(props) {
    let e = props.data;
    let tileDisabled = isTileDisabled(e);
    let iconType = tileDisabled ? IconStatus.DISABLED : IconStatus.NORMAL;

    return (
      <div className={classes.flexboxcontainer}>
        {!isEmpty(e.svcKeyDay_IsKeyDay) &&
          e.svcKeyDay_IsKeyDay.toUpperCase() === "Y" && <KeyDaysIcon type={iconType} />}
        {!isEmpty(e.svcMTO_IsMtoDay) &&
          e.svcMTO_IsMtoDay.toUpperCase() === "Y" && <PTOIcon type={iconType} />}
        {!isEmpty(e.svcSpecEvt_IsSpecEventDay) &&
          e.svcSpecEvt_IsSpecEventDay.toUpperCase() === "Y" && (
           <span onClick={gotoSpecial} style={{cursor:"pointer"}}><SpecialEventIcon type={iconType}  /></span>
          )}
        {!isEmpty(e.svcMTO_IsUnavailableDay) &&
         e.svcMTO_IsUnavailableDay.toUpperCase() === "Y" && (
         <UnavailableDaysIcon type={iconType}/>
         )}
      </div>
    );
  }

  function EditLinkView(props){
    //Sun 1 Mon 2 Tues 3 Wed 4 Thu 5 Fri 6 Sat 7
  
    let e = props.data;
    let isDisabled = isTileDisabled(e);
    let linkStyle = props.isEdit ? classes.seteditlink : classes.tilecontainer ;
    if(isDisabled){
      linkStyle = props.isEdit ? classes.seteditdisablelink : classes.tilecontainerdisable;
    }
     let lable = props.lable;
    return (
          <div>
          <u className={linkStyle} onClick={event => isDisabled ? null : selectAvailability(e)}>
            {lable}
          </u>
          </div>
    );
  }
  const getTileTitleDateDisplay = (dayName, date, monthName) => {
    let onlyDate = date;
    if (!isEmpty(date)) {
      onlyDate = date.split("-")[2];
    }
    return dayName + ", " + monthName + " " + onlyDate;
  };

  const applyDayOffAccomDailyTile = (dailyTileObj) => {
  
    return (<div className={classes.minheightoftile}>
        <div className={classes.setsubtitle}>My Availability</div>
        <div className={classes.tilecontainerua}>
          Unavailable for this day
        </div>
      </div>
    );
  }

  const isTileDisabled = (e) => {
    let isDisabled = false;
  
    //check for availability rules and daily availability status of weekdays
    isDisabled = isAvailabilityRuleTileLocked(e);
    //check accomodation rule first if type is DAY-OFF lock/disable tile
    let isAccomDayOff = isAccomTypeDAYOFF(e);
    if(isAccomDayOff){
      // override tile disabled behaviour only in case of if accom type day off is true
      isDisabled = isAccomDayOff;
    }

    
    return isDisabled;
  }

  const isAvailabilityRuleTileLocked = (e) => {
    let isDisabled = false;
    if((e.dayNbr == 1 && toUpperCaseString(rulesData.sun_editable) == 'N') ||
       (e.dayNbr == 6 && toUpperCaseString(rulesData.fri_editable) == 'N') ||
       (e.dayNbr == 7 && toUpperCaseString(rulesData.sat_editable) == 'N') ||
       (e.dayNbr == 2 && toUpperCaseString(rulesData.mon_editable) == 'N') ||
       (e.dayNbr == 3 && toUpperCaseString(rulesData.tue_editable) == 'N') ||
       (e.dayNbr == 4 && toUpperCaseString(rulesData.wed_editable) == 'N') ||
       (e.dayNbr == 5 && toUpperCaseString(rulesData.thu_editable) == 'N') ){
        isDisabled = true;
       }
      return isDisabled;
  }
  
  const isAccomTypeDAYOFF = (e) => {
    //check accomodation rule first if type is DAY-OFF lock/disable tile
    let isAccomTypeDayOFF = false;
    let isAccomExist = e.svcAccom_hasAccom == 1 ? true : false;
    if(isAccomExist){
      isAccomTypeDayOFF = toUpperCaseString(e.svcAccom_accomType) == "OFF" ? true : false; 
    }
    return isAccomTypeDayOFF;
  }

  const callBackDisabled = () => {
    if(dailyTilesData == undefined || rulesData == undefined){
        return;
    }
    let flag = false;
    for (var i = 0; i < dailyTilesData.length; i++) {
          let status = isTileDisabled(dailyTilesData[i]);
          if(status){
            flag = status;
          }else{
            flag = false;
            break;
          }
        };
  
    props.callBackAllDisabled(flag);
    return;
   }
  
  
  return (
    <div className={classes.tiles}>
      {dailyTilesData && 
        dailyTilesData.map((e) => (
          <div className={`${classes.tile} ${classes.preferred}`}>
            <div className={classes.tilehead}>
              <div className={classes.setitle}>
                <h6>
                  <b translate = "no" className={`${isTileDisabled(e) ? classes.disabled: null}`}>
                    {getTileTitleDateDisplay(
                      e.svcCal_DayName,
                      e.svcCal_CalendarDate,
                      e.svcCal_MthName
                    )}
                  </b>
                </h6>
              </div>
              <div className={classes.setitle}>
                <div className={`${classes.setitle} ${isTileDisabled(e) ? classes.disabled: null}`}>Store Hrs:</div>
                <div className={`${classes.setitle} ${isTileDisabled(e) ? classes.disabled: null}`} translate="no">
                  {isEmpty(e.svcStrHrs_Start) ? "Unavailable" : (e.svcStrHrs_Start + "-" + e.svcStrHrs_End)}
                </div>
              </div>
            </div>
            <div className={classes.tilebottom}>
              <AvailabilityInfoView data={e} />
              <TileIconsView data={e} />
            </div>
          </div>
        ))
      }
        {(showPopup === true) && appControlsData && popupdata && rulesData && (
                <AvailabilitySelectionsDailyPopup
                  appControls={appControlsData}
                  eventdata={popupdata}
                  rulesData={rulesData}
                  popupClose={popupClose}
                  onSaveSuccess={onUpdateAvailabilitySuccess}
                  ruleInfo={props.ruleInfo}
                  fscData={props.fscData}
                />
              )}
    </div>
  );
};

export default DailyAvailabilityTile;
